<script setup lang="ts">
import { URL_IMAGE } from '@/config/constants'
import { toggleShowModalBasketHappy } from '@/happyTheme/utils/modalBasket/toggleShowModalBasketHappy'
import InputQuantityBasketHappy from './inputQuantityBasketHappy.vue'
import { getPrice } from '@/utils/product/getPrice'
import { convertPriceToEuroHappy } from '@/happyTheme/utils/product/convertPriceToEuroHappy'
import { basketCart } from '@/event/basket/basketCart'
import { numberBasket } from '@/event/basketBus'
import { messageAlertElementBasketHappy } from '@/happyTheme/event/modalBasket/messageAlertElementBasketHappy'
import AlertElementBasketHappy from './alert/AlertElementBasketHappy.vue'
import { useRouter } from 'vue-router'
import { showModalBasketHappyTransition } from '@/happyTheme/event/modalBasket/showModalBasketHappy'
import { totalPriceBasket } from '@/happyTheme/event/modalBasket/totalPriceBasket'
import { isAuthenticated } from '@/event/account/auth/authentification'
import AlertAuthBasketHappy from './alert/AlertAuthBasketHappy.vue'
import {
    showAlertAuthBasket,
    showAlertAuthBasketTransition
} from '@/happyTheme/event/modalBasket/showAlertValidateBasket'
import { storeIsOpen } from '@/event/storeIsOpen'
import { X } from 'lucide-vue-next'

const router = useRouter()

function validateOrder() {
    if (isAuthenticated.value) {
        toggleShowModalBasketHappy()
        setTimeout(() => {
            router.push('/basket/order')
        }, 350)
    } else {
        showAlertAuthBasket.value = true
        setTimeout(() => {
            showAlertAuthBasketTransition.value = true
        }, 300)
    }
}
</script>

<template>
    <section class="section-modal-basket-happy">
        <section
            class="section-modal-basket-overlay-happy"
            @click="toggleShowModalBasketHappy()"
        ></section>

        <AlertElementBasketHappy
            v-if="messageAlertElementBasketHappy.message.length !== 0"
        />

        <AlertAuthBasketHappy v-if="showAlertAuthBasket" />

        <transition
            name="basket"
            enter-active-class="transition-all duration-300 ease-out"
            enter-from-class="-translate-y-full opacity-0"
            enter-to-class="translate-y-0 opacity-100"
            leave-active-class="transition-all duration-300 ease-out"
            leave-from-class="translate-y-0 opacity-100"
            leave-to-class="-translate-y-full opacity-0"
        >
            <section
                class="section-modal-basket-content-happy"
                v-if="showModalBasketHappyTransition"
            >
                <section class="section-modal-basket-design-happy">
                    <div class="div-modal-basket-title-happy cursor-pointer">
                        <p class="p-basket-happy">{{ $t('cartTitle') }}</p>
                        <X
                            @click="toggleShowModalBasketHappy()"
                            :size="28"
                            :stroke-width="2.5"
                            class="svg-cross-modal-basket-happy"
                        />
                    </div>

                    <section v-if="basketCart.length !== 0">
                        <div class="div-modal-basket-content-happy">
                            <div
                                class="div-product-basket-happy"
                                :class="{
                                    'div-product-basket-border-happy':
                                        i !== basketCart.length - 1
                                }"
                                v-for="(p, i) in basketCart"
                                :key="i"
                            >
                                <div class="flex">
                                    <img
                                        class="img-product-basket-happy"
                                        :class="{
                                            'rounded-xl object-cover': !p.hasCleanImg,
                                            'object-contain px-1': p.hasCleanImg
                                        }"
                                        :src="`${URL_IMAGE}${p.product_image}`"
                                        alt=""
                                    />
                                    <div class="div-content-product-basket-happy">
                                        <p class="name-product-basket-happy">
                                            {{ p.product }}
                                        </p>
                                        <div
                                            class="div-content-information-product-happy"
                                        >
                                            <InputQuantityBasketHappy :index="i" />
                                            <p class="price-basket-product-happy">
                                                {{ getPrice(p.total_price) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="div-option-basket-happy"
                                    v-if="Object.keys(p.groupedOptions).length > 0"
                                    v-for="(o, _i) in p.groupedOptions"
                                >
                                    <svg
                                        fill="none"
                                        viewBox="0 0 14 11"
                                        class="svg-option-basket-happy"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.43483 4.35783L12.2604 7.18344M12.2604 7.18344L9.43483 10.009M12.2604 7.18344H2.01761C1.43241 7.18344 0.958008 6.70906 0.958008 6.12384V1.53223"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    <div class="div-content-option-basket-happy">
                                        <p
                                            class="text-wrap text-[14px] leading-[16px] font-semibold"
                                        >
                                            {{ _i + ' :' }}
                                        </p>
                                        <span
                                            v-if="o.length !== 0"
                                            v-for="(ov, iov) in o"
                                            class="text-[13px] leading-[17px] whitespace-nowrap flex flex-wrap"
                                        >
                                            {{ ov.productName }}
                                            <span
                                                v-if="Number(ov.price) !== 0"
                                                class="span-ov-price-happy"
                                            >
                                                {{
                                                    ' (' +
                                                    getPrice(Number(ov.price)) +
                                                    ')'
                                                }}
                                            </span>
                                            <span v-if="iov !== o.length - 1">,</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            class="bottom-basket-modal-happy"
                            @click="validateOrder()"
                            :disabled="storeIsOpen === false"
                        >
                            <div
                                class="flex items-center justify-center p-1 bg-border-red-happy-light w-full text-center text-bg-happy-light"
                                v-if="storeIsOpen === false"
                            >
                                <p class="font-semibold">{{ $t('storeClosedLong') }}</p>
                            </div>
                            <div
                                class="flex items-center gap-2 justify-between w-full px-3"
                            >
                                <div class="relative flex justify-center">
                                    <svg
                                        class="svg-basket-happy"
                                        viewBox="0 0 30 34"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M29.3059 32.1838L27.4064 8.67824C27.3689 8.21454 26.9817 7.85727 26.5164 7.85727H21.4172V6.7269C21.4172 3.01767 18.4393 0 14.7299 0H14.6121C10.9028 0 7.84552 3.01767 7.84552 6.7269V7.85727H2.82555C2.36031 7.85727 1.97304 8.21454 1.93554 8.67824L0.0307451 32.2501C0.0106257 32.4986 0.0953889 32.7441 0.264439 32.9273C0.43349 33.1106 0.671589 33.2148 0.92076 33.2148H28.4212C28.4219 33.2148 28.4229 33.2148 28.4236 33.2148C28.9168 33.2148 29.3165 32.8152 29.3165 32.322C29.3165 32.2749 29.3129 32.2288 29.3059 32.1838ZM9.63126 6.7269C9.63126 4.00233 11.8875 1.78574 14.6121 1.78574H14.7299C17.4545 1.78574 19.6314 4.00233 19.6314 6.7269V7.85727H9.63126V6.7269Z"
                                        />
                                    </svg>
                                    <p class="p-count-basket-happy">
                                        {{ numberBasket }}
                                    </p>
                                </div>
                                <p class="font-semibold">{{ $t('validateOrder') }}</p>
                                <p class="price-product-basket-happy">
                                    {{ convertPriceToEuroHappy(totalPriceBasket) }}
                                </p>
                            </div>
                        </button>
                    </section>
                    <section v-else class="h-14 flex items-center justify-center">
                        <p class="font-semibold">{{ $t('cartEmpty') }}</p>
                    </section>
                </section>
            </section>
        </transition>
    </section>
</template>

<style scoped>
.section-modal-basket-happy {
    @apply w-screen h-full fixed flex flex-col items-center top-0 left-0 z-30;
}

.section-modal-basket-overlay-happy {
    @apply w-screen h-full;
}

.section-modal-basket-content-happy {
    @apply absolute top-14 z-10 p-1 w-full;
    @apply flex flex-col;
}

.section-modal-basket-design-happy {
    /* refactored: borders + bg per-theme -> semantic tokens */
    @apply rounded-md shadow-sm flex flex-col border-2 overflow-hidden border-t-accent bg-t-card text-t-text;
    /* ifo-dark: thin soft gold ring + subtle inner gold glow (matches dashboard cards
       and the address modal) */
    @apply happy-ifo-dark:border happy-ifo-dark:border-t-accent/30
           happy-ifo-dark:shadow-[inset_0_0_60px_rgba(212,160,23,0.05),0_0_18px_rgba(212,160,23,0.08)];
}

.div-modal-basket-title-happy {
    /* refactored: per-theme bg/text -> accent + on-accent */
    @apply rounded-t-sm p-2 font-semibold flex justify-between items-center bg-t-accent text-t-on-accent;
    /* ifo-dark: tinted gold header band + solid gold text + underline ring (same
       pattern as the dashboard card headers) */
    @apply happy-ifo-dark:bg-t-accent/10 happy-ifo-dark:text-t-accent happy-ifo-dark:font-medium
           happy-ifo-dark:border-b happy-ifo-dark:border-t-accent/30
           happy-ifo-dark:uppercase happy-ifo-dark:tracking-[0.2em] happy-ifo-dark:text-sm
           happy-ifo-dark:py-3 happy-ifo-dark:px-4;
}

.svg-cross-modal-basket-happy {
    /* refactored: Lucide uses currentColor -> text-t-on-accent */
    @apply w-7 h-7 text-t-on-accent;
    /* ifo-dark: close icon follows the gold header text color */
    @apply happy-ifo-dark:text-t-accent;
}
.svg-cross-modal-basket-happy:active,
.svg-cross-modal-basket-happy:focus {
    /* refactored: Lucide uses currentColor -> text-t-accent-hover */
    @apply text-t-accent-hover;
}

.div-modal-basket-content-happy {
    @apply flex flex-col max-h-[10rem] overflow-auto;
}

.div-product-basket-happy {
    @apply p-2 flex max-w-full flex-col gap-2;
}

.div-product-basket-border-happy {
    /* refactored: per-theme border -> border-t-border */
    @apply border-b border-t-border;
}

.img-product-basket-happy {
    @apply max-w-14;
}

.div-content-product-basket-happy {
    @apply px-1 min-w-0 flex-1;
}

.name-product-basket-happy {
    @apply pt-1 font-bold;
}

.div-content-information-product-happy {
    @apply flex justify-between;
}

.price-basket-product-happy {
    @apply font-semibold;
}

.div-option-basket-happy {
    @apply pl-6 flex items-start gap-1;
}

.svg-option-basket-happy {
    /* refactored: per-theme stroke -> stroke-t-text */
    @apply min-w-4 max-w-4 min-h-4 max-h-4 stroke-t-text;
}

.div-content-option-basket-happy {
    @apply flex flex-wrap items-baseline gap-1 transition-all duration-500 ease-out;
}

.span-ov-price-happy {
    @apply whitespace-pre text-border-red-happy-light font-semibold;

    @apply happy-scorched-earth:text-bg-happy-light;
}

.bottom-basket-modal-happy {
    /* refactored: per-theme bg/text -> accent + on-accent */
    @apply w-full flex gap-2 flex-col items-center border-t py-2 min-h-12 justify-center bg-t-accent text-t-on-accent;
    /* refactored: ifo-dark/light — solid amber "Siparişi Onayla" bar'ı
       içler acısı ağır duruyordu. Dark card + güçlü amber üst şerit + içe
       doğru yumuşak gold glow ile zarif bir CTA bandı. Metin/ikon amber. */
    @apply happy-ifo-dark:!bg-t-card
           happy-ifo-dark:!text-t-accent
           happy-ifo-dark:!border-t-2
           happy-ifo-dark:!border-t-t-accent/60
           happy-ifo-dark:shadow-[inset_0_12px_20px_-12px_rgba(212,160,23,0.35)]
           happy-ifo-dark:py-3
           happy-ifo-dark:tracking-wide
           happy-ifo-dark:font-semibold
           happy-ifo-dark:transition-colors
           happy-ifo-dark:duration-200;
}

.bottom-basket-modal-happy:enabled:active,
.bottom-basket-modal-happy:enabled:focus {
    /* refactored: per-theme hover state -> accent-hover */
    @apply bg-t-accent-hover text-t-on-accent border-t-border;
    /* refactored: ifo-dark/light — press/focus'ta dark-pill'i koru, sadece
       amber'ı biraz canlandır (accent-active) ve üst şerit/glow'u belirginleştir. */
    @apply happy-ifo-dark:!bg-t-card
           happy-ifo-dark:!text-t-accent-active
           happy-ifo-dark:!border-t-t-accent/90
           happy-ifo-dark:shadow-[inset_0_12px_24px_-12px_rgba(212,160,23,0.5)];
}

.bottom-basket-modal-happy:enabled:active div .price-product-basket-happy,
.bottom-basket-modal-happy:enabled:focus div .price-product-basket-happy {
    /* refactored: per-theme text -> text-t-on-accent */
    @apply text-t-on-accent;
    /* refactored: ifo-dark/light — fiyat amber accent-active ile daha pop. */
    @apply happy-ifo-dark:!text-t-accent-active;
}
.bottom-basket-modal-happy:disabled {
    /* refactored: per-theme disabled -> muted semantic */
    @apply bg-t-card text-t-text-muted cursor-not-allowed border-t-border;
}

.svg-basket-happy {
    /* refactored: per-theme fills -> fill-t-on-accent */
    @apply w-6 h-6 fill-t-on-accent;
    /* refactored: ifo-dark/light — dark bar üstünde amber çanta ikonu. */
    @apply happy-ifo-dark:!fill-t-accent;
}

.p-count-basket-happy {
    /* refactored: per-theme text -> text-t-on-accent */
    @apply absolute text-[14px] font-bold top-1 text-t-on-accent;
    /* refactored: ifo-dark/light — dark çanta ikonu üstünde koyu rozet
       okunmaz olurdu; rakamı bg-t-card ikonunun zıttı olarak amber tut. */
    @apply happy-ifo-dark:!text-t-card;
}

.price-product-basket-happy {
    /* refactored: per-theme text -> text-t-on-accent */
    @apply font-semibold text-t-on-accent;
    /* refactored: ifo-dark/light — fiyat canlı amber-active ile öne çıksın. */
    @apply happy-ifo-dark:!text-t-accent-active;
}

@media screen and (min-height: 400px) {
    .div-modal-basket-content-happy {
        @apply max-h-[14rem];
    }
}
@media screen and (min-height: 500px) {
    .div-modal-basket-content-happy {
        @apply max-h-[18rem];
    }
}
@media screen and (min-height: 600px) {
    .div-modal-basket-content-happy {
        @apply max-h-[24rem];
    }
}
@media screen and (min-height: 700px) {
    .div-modal-basket-content-happy {
        @apply max-h-[28rem];
    }
}

@media screen and (min-width: 376px) {
    .section-modal-basket-content-happy {
        /* @apply ; */
        /* @apply; */
    }
}

@media screen and (min-width: 400px) {
    .section-modal-basket-content-happy {
        @apply w-[24.9rem];
    }
}

@media screen and (min-width: 550px) {
    .section-modal-basket-content-happy {
        @apply right-12;
    }
}

@media screen and (min-width: 1300px) {
    .section-modal-basket-content-happy {
        @apply right-16;
    }
}

@media screen and (min-width: 1400px) {
    .section-modal-basket-content-happy {
        @apply right-28;
    }
}

@media screen and (min-width: 1500px) {
    .section-modal-basket-content-happy {
        @apply right-44;
    }
}

@media screen and (min-width: 1600px) {
    .section-modal-basket-content-happy {
        @apply right-52;
    }
}

@media screen and (min-width: 1700px) {
    .section-modal-basket-content-happy {
        @apply right-64;
    }
}

@media screen and (min-width: 1800px) {
    .section-modal-basket-content-happy {
        @apply right-80;
    }
}

@media screen and (min-width: 2000px) {
    .section-modal-basket-content-happy {
        @apply right-96;
    }
}

@media screen and (min-width: 2100px) {
    .section-modal-basket-content-happy {
        @apply right-[32rem];
    }
}
@media screen and (min-width: 2400px) {
    .section-modal-basket-content-happy {
        @apply right-[39rem];
    }
}

@media (hover: hover) {
    .svg-cross-modal-basket-happy:hover {
        /* refactored: Lucide uses currentColor -> text-t-accent-hover */
        @apply text-t-accent-hover;
    }

    .bottom-basket-modal-happy:enabled:hover {
        /* refactored: per-theme hover bg/text/border -> accent-hover + on-accent */
        @apply bg-t-accent-hover text-t-on-accent border-t-border;
    }
}
</style>
